// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"4512f1cf","536":"bf59d20a","703":"deced560","787":"ff98dd28"}[chunkId] + ".chunk.js";
};